import { BaseAPI } from './Common';

class Notification extends BaseAPI {
    sendEmail(source: string, payload: any): Promise<any> {
        return this.makeRequest(`${source}`, "post", payload)
    }
}   

export const notification = new Notification("notifications");